import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { loadGoogleTag } from '../utils/gtag';

const CookieBanner = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    loadGoogleTag();
    setVisible(false);
  };

  const handleEssentialOnly = () => {
    localStorage.setItem('cookieConsent', 'essential');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t-2 border-gray-200 shadow-2xl" data-testid="cookie-banner">
      <div className="max-w-7xl mx-auto p-4 sm:p-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex-1">
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
              <strong>EventConnect</strong> verwendet Cookies, um die Nutzung der Website zu verbessern und bestimmte Funktionen bereitzustellen. 
              <button
                onClick={() => navigate('/datenschutz')}
                className="text-[#2B2142] hover:underline ml-1"
              >
                Weitere Informationen findest du in unserer Datenschutzerklärung.
              </button>
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
            <button
              onClick={handleEssentialOnly}
              className="px-6 py-2 border-2 border-gray-300 hover:border-gray-400 text-gray-700 font-semibold rounded-lg transition-colors whitespace-nowrap"
              data-testid="cookie-essential"
            >
              Nur notwendige
            </button>
            <button
              onClick={handleAccept}
              className="px-6 py-2 bg-[#2B2142] hover:bg-[#1E1730] text-white font-semibold rounded-lg transition-colors whitespace-nowrap"
              data-testid="cookie-accept"
            >
              Alle akzeptieren
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
